var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { I18nextPhraseBackend } from '@phrase/i18next-backend';
import { detectLocale } from '../util';
import { allLocales } from '../models';
import PhraseInContextEditorPostProcessor from 'i18next-phrase-in-context-editor-post-processor';
import { inContextEditorEnabled } from '../util/inContextEditorEnabled';
// Just a wrapper around the init function of i18next with some default arguments.
// We made the 'resources' parameter required to avoid any errors.
export var init = function (_a) {
    var phrase = _a.phrase, _b = _a.lng, lng = _b === void 0 ? detectLocale() : _b, _c = _a.supportedLngs, supportedLngs = _c === void 0 ? allLocales : _c, _d = _a.fallbackLng, fallbackLng = _d === void 0 ? ['en'] : _d, backend = _a.backend, args = __rest(_a, ["phrase", "lng", "supportedLngs", "fallbackLng", "backend"]);
    var instance = i18n.use(initReactI18next);
    if (backend) {
        instance.use(I18nextPhraseBackend);
    }
    if (phrase) {
        instance.use(new PhraseInContextEditorPostProcessor(__assign({ phraseEnabled: !!phrase.allowInContextEditor && inContextEditorEnabled, projectId: phrase.projectId, accountId: phrase.accountId }, (phrase.inContextEditorOptions || {}))));
    }
    return instance.init(__assign({ lng: lng, supportedLngs: supportedLngs, fallbackLng: fallbackLng, backend: backend, postProcess: phrase ? ['phraseInContextEditor'] : args.postProcess }, args));
};
